import { c as _c } from "react/compiler-runtime";
import { type QuickSearchContentResults, useGlobalSearchContext } from '@/contexts/GlobalSearchContext';
import useTranslation from '@/hooks/useTranslation';
import { useRef } from 'react';
import { ResultGroup } from './ResultGroup';
export const JumpToResultsSection = () => {
  const $ = _c(9);
  const {
    currentJumpToResults,
    globalSearchResults
  } = useGlobalSearchContext();
  const {
    t
  } = useTranslation("common");
  const ref = useRef(null);
  let jumpToItems;
  let t0;
  if ($[0] !== currentJumpToResults || $[1] !== globalSearchResults) {
    t0 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        resultGroups
      } = globalSearchResults ?? {};
      const {
        authors
      } = resultGroups as QuickSearchContentResults['resultGroups'] ?? {};
      if (currentJumpToResults?.length === 0 && authors?.items.length === 0) {
        t0 = null;
        break bb0;
      }
      jumpToItems = currentJumpToResults.map(_temp);
      if (authors?.items.length > 0) {
        jumpToItems.push(...authors.items.map(_temp2));
      }
    }
    $[0] = currentJumpToResults;
    $[1] = globalSearchResults;
    $[2] = jumpToItems;
    $[3] = t0;
  } else {
    jumpToItems = $[2];
    t0 = $[3];
  }
  if (t0 !== Symbol.for("react.early_return_sentinel")) {
    return t0;
  }
  let t1;
  if ($[4] !== t) {
    t1 = t("Navigation.QuickSearch.jump_to");
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== jumpToItems || $[7] !== t1) {
    t2 = <ResultGroup analyticsBaseId="Quick Search: Jump To" items={jumpToItems} title={t1} wrapperRef={ref} />;
    $[6] = jumpToItems;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
function _temp(result) {
  return {
    url: result.url,
    title: result.title,
    subTitle: result.parentSection
  };
}
function _temp2(author) {
  return {
    url: author.url,
    title: author.title,
    subTitle: "Author"
  };
}